import { AntennaLight } from '@wwf/sdk';
import { AntennaLightCard } from './show/AntennaLightCard';

export const antennaOptionText = <AntennaLightCard noLink />;
export const antennaInputText = (choice: AntennaLight) => choice.name;
